export const HALIDE_LOGIC = {
  description: "Halides Identification Rules",
  
  coreRules: `
=== 卤化物矿物的终极鉴定法则 (Halides Diagnostic Protocol) ===

[5.1 基础盐类：岩盐与钾盐的战争 (The Core Salts: Halite vs Sylvite)]
*   **岩盐 (Halite - NaCl)**: 氯化钠本尊。它是卤化物的基准。必须寻找**完美的立方体晶形 (Perfect Cubic Crystals)** 与**阶梯状的立方体解理**。外观通常是透明到乳白色，有时微带杂色（由于杂质）。
*   **钾盐 (Sylvite - KCl)**: 岩盐的影子。外观几乎和岩盐一模一样，也是透明/白色的块状或立方体。
    *   【终极区分锚点】：如果在博物馆标本描述或测试反馈中遇到“尝起来的味道”——**岩盐是纯咸味**，而**钾盐不仅咸，而且具有明显的【苦涩味】 (Bitter taste)**。如果在图片中它失去了完美的立方体形状而偏向不规则致密块状，结合“钾盐”标签，可以确认。

[5.2 结晶与光学的霸主：萤石与冰晶石 (The Optical Giants: Fluorite vs Cryolite)]
*   **萤石 (Fluorite - CaF2)**: 卤化物中最华丽的结晶矿物。必须寻找：**立方体 (Cubic)** 或者 **八面体 (Octahedral)** 晶系，并且通常伴随有引人注目的颜色分带（紫、绿、黄、蓝皆有可能）。
    *   【关键破绽】：尽管长得像冰糖或宝石，但它有极其特征的**四组完全解理 (Perfect octahedral cleavage)**。在边角断裂处，绝不是贝壳状的玻璃断口，而是平整的切面。
*   **冰晶石 (Cryolite - Na3AlF6)**: 罕见的熔剂矿物。外观看起来像**半透明到白色的冰块或冷冻的油脂 (Ice-like or Greasy mass)**。它极少形成好看的晶体，大多为致密块体。
    *   【极端物理锚点】：它的折射率和水的折射率极其接近。如果在描述中提到“放入水中后几乎隐形”或者“看起来像融化了一半的雪球”，直接锁定冰晶石。

[5.3 铜银的高阶次生变体 (The Rare Cu & Ag Halides)]
*   **斜氯铜矿 (Atacamite)**: 极其致密的铜氧化层常客。外观通常呈现暗绿色到翠绿色的砂状、纤维状或细小的斜方晶体结块，常附着在干旱地区的其他含铜岩石表面。
    *   【辨识锚点】：与孔雀石的翠绿不同，斜氯铜矿的绿色更深邃、“发干”，且常见于极度干旱环境（如沙漠铜矿的氧化带）。
*   **角银矿 (Chlorargyrite / Horn Silver)**: 银的次生氯化物。
    *   【形态锚点】：千万不要寻找金属光泽！它长得像是一块**脏兮兮的蜡块、油脂块或变色的角质物 (Horn-like or Waxy crust)**。颜色从灰白到黄绿色。它最初可能是透明的，但在光照下会极速变暗成紫黑色或灰黑色。它是风化带中寻找银矿的绝对指示物。
*   **碘银矿 / 呕吐石 (Iodyrite / Iodargyrite) (附带 溴银矿 Bromargyrite 特征)**:
    *   **碘银矿**: 颜色常表现为**淡黄、树脂黄到黄绿色**。极其柔软（硬度仅为1-1.5，能用指甲轻易刮下），具有树脂到金刚光泽。晶体多薄板状，但更常以鳞片状或块状出现。
    *   【极度稀有锚点】：“呕吐石”这是一个极度罕见的业内俗称或者误译，可能指向其复杂的混合状态或风化后极其难看的形态，混合了角银矿、碘银矿和溴银矿的暗淡质地。若图片中看到铅灰/黄灰交杂，毫无金属光感，像某种凝固的灰泥粘合在岩石上，并带有明显的银矿次生标签，立刻归类为此系列。
`,

  diagnosticTests: `
- 面对透明/白色的立方体结晶块：如果它只有立方双晶，那是岩盐 (Halite)；如果有紫/绿等鲜艳颜色并切角平整，那是萤石 (Fluorite)。
- 如果一块透明白色石头毫无晶形、长得像一块浑油或冰坨子，极度大概率是冰晶石 (Cryolite)。
- 面对干旱铜矿表面的暗绿色砂状沉淀，除了孔雀石外，必须验证是否为斜氯铜矿 (Atacamite)。
- 如果看到表面附着像某种脏黄绿色或紫灰色烂蜡/角质层的标本，它绝不是普通泥土，这是银矿化极度富集的次生卤化物：角银矿/碘银矿 (Horn Silver系列)。
`
};
